var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system_name",staticStyle:{"cursor":"pointer"}},[_vm._v(" "+_vm._s(_vm.title)+" "+_vm._s(_vm.$t("original.foottitle"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }